<div class="html-viewer"
     [outerHTML]="safeHTML"></div>